/* global angular */
( function () {
	'use strict';

	function FormulaParserCtrl ( _, mathOperatorService, ERROR_MSGS ) {
		var self = this;

		function getOperatorKeys ( operatorObj ) {
			return operatorObj.key;
		}

		var operators = ( mathOperatorService.getDisplay() || [] ).map( getOperatorKeys );

		function appendIfNumber ( value ) {
			var ptr = value[ value.length - 1 ] || '';

			if ( isNaN( parseInt( ptr, 10 ) ) && ptr.indexOf( '[' ) < 0 && ptr.indexOf( ']' ) < 0 ) {
				return value.split( ']' ).join( '];' ).split( '[' ).join( ';[' );
			}

			return value + ';';
		}

		function valueMapper ( value ) {
			return appendIfNumber( value );
		}

		function doSplice ( formula, separator ) {
			separator.map( function ( optr ) {
				formula = ( formula || '' )
				.split( optr )
				.map( valueMapper )
				.join( optr + ';' );
			} );
			return formula;
		}

		function getIndexForMissingItem ( id ) {
			var idArray = ( id || '' ).split( '-' );

			if ( idArray[ 0 ].length < 5 ) {
				return -1;
			}

			if ( ( idArray.length > 4 && !angular.isNumber( idArray[ 0 ] ) || id === ERROR_MSGS.tplFormulaMissingPrefix ) ) {
				return -2;
			}
		}

		function getIndexFromCollection ( id ) {
			var collection = self.indicators || self.groups || [];
			var index      = _.findIndex( collection, { 'id' : id } );

			if ( index === -1 ) {
				index = getIndexForMissingItem( id );
			}

			return index;
		}

		function replaceIdWithPrifix ( item ) {
			var index       = getIndexFromCollection( item );
			var formulaItem = item;

			if ( index >= 0 ) {
				formulaItem = self.prefix + ' ' + ( index + 1 );
			}

			if ( index === -2 ) {
				formulaItem = ERROR_MSGS.tplFormulaMissingPrefix + ' ' + self.prefix;
			}

			return formulaItem;
		}

		function convertFormulaToPrefixedFormula ( formula ) {
			return ( formula || '' ).split( ':' ).map( replaceIdWithPrifix ).join( '' );
		}

		function getItemWithValues ( item ) {
			return item.length;
		}

		function parseFormula ( formula ) {
			return doSplice( convertFormulaToPrefixedFormula( formula ), operators ).split( ';' ).filter( getItemWithValues );
		}

		self.parseFormula = parseFormula;
	}

	angular
		.module( 'app.components' )
		.controller( 'FormulaParserCtrl', FormulaParserCtrl );

	FormulaParserCtrl.$inject = [ '_', 'mathOperatorService', 'ERROR_MSGS' ];
} )( );
